import React from "react";
import { Container } from "react-bootstrap";
import Spinner from "../components/Elements/Spinner";

export default function Loading() {
  return (
    <div style={{ minHeight: "inherit" }}>
      <Container
        style={{ backgroundColor: "#fff", position: "relative", minHeight: "inherit" }}
      >
        <Spinner />
      </Container>
    </div>
  );
}
